define('views/modules/calendar/animated-session/exercise/weight/history/weight-history-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'services/i18n',
    // views
    'views/modules/calendar/animated-session/exercise/weight/history/weight-history-content',
    // parent view
    'views/modules/calendar/animated-session/exercise/lists/exercise-list-item',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/history/weight-history-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // views
    VWeightHistoryContent,
    // parent view
    VExerciseListItem,
    // templates
    TWeightHistoryListItem
) {

    var VWeightHistoryListItem = Backbone.Epoxy.View.extend({
        template: TWeightHistoryListItem,
        className: "history",
        weightContentView: VWeightHistoryContent,

        regions: {
            content: '.exercise-box-table'
        },

        initialize: function(opt) {
            this.options = opt || {};
            var view = this.view = {},
                model = this.model, // week
                session = this.session = opt.session,
                exercise = opt.exercise,
                sets = opt.sets;

            if (exercise.isWeight()) {
                view.content = view.weight = new this.weightContentView({
                    model: model,
                    exercise: exercise,
                    item: opt.item,
                    sets: sets,
                    summary: true
                });
            } else if (exercise.isCardio()) {
                view.content = view.cardio = new this.cardioContentView({
                    model: model,
                    exercise: exercise
                });
            }
        },

        render: function() {
            var model = this.model,
                weekDay = "",
                date = this.options.date;

            // if (this.options.calendarItem !== null) {
            //     weekDay = this.options.calendarItem.getDate().format('dddd');
            //     date = this.options.calendarItem.getDate().format('YYYY-MM-DD');
            // }

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                weekDay: weekDay,
                date: date,
                numSets: this.options.sets.numSets,
                setsTranslation: i18n.t('calendar:SetsWithCount', { count: this.options.sets.numSets })
            })));

            this.generateZones()
                .applyBindings();

            this.assign(this.view.content, this.zone.$content);

            return this;
        },

    });

    return VWeightHistoryListItem;

});

